import {
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../Status';

type PutCustomFieldResponsesParams = {
  bookingId: string;
  customFieldResponses: { id: string; name: string; value: string }[];
};

export function putCustomFieldResponses(params: PutCustomFieldResponsesParams) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: 'bookings/custom-field-responses',
        method: 'put',
        data: JSON.stringify(params),
        success: (response: any) => {
          dispatch(requestSuccess(response));
          enqueueSnackbarHandler(
            dispatch,
            { updateBookingCustomFieldResponses: true },
            'success',
          );
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          error?.payload?.userPermissionError
            ? enqueueSnackbarHandler(dispatch, error.payload, 'error')
            : enqueueSnackbarHandler(
                dispatch,
                { updateBookingCustomFieldResponsesFailed: true },
                'error',
              );
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE,
    payload: null,
  };
}

export function requestSuccess(responseJSON: any) {
  return {
    type: ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: any) {
  return {
    type: ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE,
    payload: responseJSON,
  };
}
